window.SepaExport = {
	/**
	 * 
	 * @param {type} rowSelection
	 * @returns {undefined}
	 */
	massSepaExport: function(rowSelection){
		if (rowSelection.length > 1000) {
			MyWindow.alert(Loc.g("Vous ne pouvez pas sélectionner plus de 1000 éléments."), { type: "error" });
			return;
		}

		var title = Loc.g("Exporter la sélection dans un fichier SEPA");
		var options = {
			title	: title,
			width: 1200,
			buttons	: [{
					text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
				}],
				callback	: function() {
					SepaExport.prepareMassSepaExport();
				}
		};
		MyWindow.load("sepaexport", {action:"massSepaExport",rowSelection:rowSelection}, options);

	},
	
	prepareMassSepaExport: function() {
		// only one bank account
		var corpOnlyOneBankAccount = $('#corpOnlyOneBankAccount').val();
		if (corpOnlyOneBankAccount == 'Y'){
			var newButtons = [
				{
					text : Loc.g("Fermer"),
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Télécharger"),
					'class' : 'btn btn-primary',
					click : function(){
						$('#massSepaExportForm').submit();
						MyWindow.close();
						Listing.update("docinvoicesListing", false);
					}
				}
			];
			MyWindow.addOption('buttons', newButtons);
		}
	},




    massPurSepaExport: function(rowSelection){

        var title = Loc.g("Exporter la sélection dans un fichier SEPA pour ordre de virement");
        var options = {
            title	: title,
            width: 1200,
            buttons	: [{
                text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}
            }],
            callback	: function() {
                SepaExport.prepareMassPurSepaExport();
            }
        };
        MyWindow.load("sepaexport", {action:"massPurSepaExport",rowSelection:rowSelection}, options);

    },

    prepareMassPurSepaExport: function() {

	    if($('#canExport').val() > 0){
            var newButtons = [
                {
                    text : Loc.g("Fermer"),
                    'class' : 'btn btn-default',
                    click : function(){$(this).dialog("close");}
                },
                {
                    text : Loc.g("Télécharger"),
                    'class' : 'btn btn-primary',
                    click : function(){
                        $('#massPurSepaExportForm').submit();
                        MyWindow.close();
                    }
                }
            ];
            MyWindow.addOption('buttons', newButtons);
        }

    }



};
